import React, { useState, useEffect } from "react";
import { Carousel } from "react-bootstrap";
import axios from "axios";
import homepageimg from "../AlIimage/homepageimg.png";

const HeroBanner = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get("/api/homeBanner/getAll")
      .then((res) => {
        const data = res.data?.homeBanner || [];
        // Only show active banners if the field exists, otherwise show all
        const active = data.filter((b) => b.isActive !== false);
        setBanners(active);
        setLoading(false);
      })
      .catch(() => {
        setBanners([]);
        setLoading(false);
      });
  }, []);

  // While loading or if no banners exist, show the default static image
  if (loading || banners.length === 0) {
    return (
      <div style={{ width: "100%" }}>
        <img src={homepageimg} alt="Jatin Mor Jewels" style={{ width: "100%", display: "block" }} />
      </div>
    );
  }

  // Single banner — no carousel needed
  if (banners.length === 1) {
    const b = banners[0];
    const url = b.image?.[0]?.url;
    if (!url) {
      return (
        <div style={{ width: "100%" }}>
          <img src={homepageimg} alt="Jatin Mor Jewels" style={{ width: "100%", display: "block" }} />
        </div>
      );
    }
    return b.mediaType === "video" ? (
      <video
        src={url}
        autoPlay
        loop
        muted
        playsInline
        style={{ width: "100%", display: "block" }}
      />
    ) : (
      <img src={url} alt={b.name || "Banner"} style={{ width: "100%", display: "block" }} />
    );
  }

  // Multiple banners — carousel
  return (
    <Carousel fade interval={4000} controls={banners.length > 1} indicators={banners.length > 1}>
      {banners.map((b) => (
        <Carousel.Item key={b._id}>
          {b.mediaType === "video" ? (
            <video
              src={b.image?.[0]?.url}
              autoPlay
              loop
              muted
              playsInline
              style={{ width: "100%", display: "block" }}
            />
          ) : (
            <img
              src={b.image?.[0]?.url}
              alt={b.name || "Banner"}
              style={{ width: "100%", display: "block" }}
            />
          )}
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default HeroBanner;
